@let isLoading = loading();
@let isUploading = uploading();
@let dragOverValue = dragOver();
@let configValue = config();

<mat-card
  *transloco="let t; prefix: `${i18nScope()}.DROP_ZONE`"
  class="overflow-hidden min-h-[200px] flex items-center justify-center"
  [class.!bg-[var(--mat-sys-error-container)]]="hasError()"
  [class.!shadow-none]="hideCardShadow()"
>
  <mat-card-content class="text-center py-8 px-4 w-full select-none">
    <div class="flex flex-col items-center gap-4">
      @if (dragOverValue) {
        <mat-icon
          @fadeIn2XFastEnter
          class="!w-[48px] !h-[48px]"
          [customMatSvgIcon]="centerDragOverIcon()"
        />
      } @else {
        <mat-icon
          @fadeIn2XFastEnter
          class="!w-[48px] !h-[48px]"
          [customMatSvgIcon]="centerIcon()"
        />
      }
      <div class="upload-text">
        <p>
          @if (dragOverValue) {
            <b @fadeIn2XFastEnter>{{ t('DROP_FILES_HERE') }}</b>
          } @else if (isUploading) {
            <b @fadeIn2XFastEnter>{{ t('UPLOADING') }}</b>
          } @else if (isLoading) {
            <b @fadeIn2XFastEnter>{{ t('LOADING') }}</b>
          } @else {
            @if (config().multiple) {
              <b @fadeIn2XFastEnter>{{ t('DRAG_OR_SELECT_MULTIPLE') }}</b>
            } @else {
              <b @fadeIn2XFastEnter>{{ t('DRAG_OR_SELECT') }}</b>
            }
          }
        </p>
        <small class="block">{{
          t('FILE_TYPE', { types: config().accept | joinMimeTypeToExtension })
        }}</small>
        @if (configValue.maxSize | isNumber) {
          <small class="block">{{
            t('MAX_SIZE', { size: config().maxSize | formatFileSize })
          }}</small>
        }
        @if ((configValue | isMultipleFileUploadConfig) && (configValue.maxFiles | isNumber)) {
          <small class="block">{{ t('MAX_FILE', { count: configValue.maxFiles }) }}</small>
        }
      </div>
    </div>
    @if (isLoading) {
      <pct-common-progress-bar />
    }
  </mat-card-content>
  <div
    class="!absolute top-0 left-0 right-0 bottom-0"
    matRipple
    [matRippleDisabled]="isLoading"
  ></div>
</mat-card>
